import React from "react";
import { OfferCard } from "./OfferCard";
import { SectionHeading } from "./SectionHeading";
import { finalOfferHighlights } from "../data/content";
export function FinalOffer({
  id
}: {
  id: string;
}) {
  return <section id={id} className="bg-peach px-4 py-16" aria-labelledby={`${id}-title`} data-id="element-130" data-mp="1ghgih6gmihix">
      <div className="mx-auto max-w-6xl" data-id="element-131" data-mp="1cek7o1xbrppj">
        <SectionHeading id={`${id}-title`} title="Everything you need to build with confidence" accent="All in one pack" data-id="element-132" data-mp="1cdikx06y5erz" />
        <div className="mt-10" data-id="element-133" data-mp="1lfi2btlvikvg">
          <OfferCard title="The complete Woodworking Ready™ collection" highlights={finalOfferHighlights} data-id="element-134" data-mp="1lg9xj3bk6gl7" />
        </div>
      </div>
    </section>;
}